import { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

export const typographyCustomizations: Components<Theme> = {
  MuiTypography: {
    styleOverrides: {
      h1: ({ theme }) => ({
        [theme.breakpoints.down('md')]: {
          fontSize: '24px', // Reduced from default 2.125rem
          fontWeight: 600,    // Reduced from default 700
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        },
      }),
      h2: ({ theme }) => ({
        [theme.breakpoints.down('md')]: {
          fontSize: '22px', // Reduced from default 1.5rem
          fontWeight: 600,    // Reduced from default 700
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        },
      }),
      h3: ({ theme }) => ({
        [theme.breakpoints.down('md')]: {
          fontSize: '18px', // Reduced from default 1.25rem
          fontWeight: 600,    // Reduced from default 700
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        },
      }),
      h4: ({ theme }) => ({
        [theme.breakpoints.down('md')]: {
          fontSize: '16px', // Reduced from default 1.25rem
          fontWeight: 500,    // Reduced from default 700
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        },
      }),
      h5: ({ theme }) => ({
        color: theme.palette.text.secondary, // Default to secondary text color
        [theme.breakpoints.down('md')]: {
          fontSize: '14px',   // Reduced from default 1.25rem
          fontWeight: 500,    // Reduced from default 700
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        },
      }),
      h6: ({ theme }) => ({
        color: theme.palette.text.secondary, // Default to secondary text color
        [theme.breakpoints.down('md')]: {
          fontSize: '13px', // Reduced from default 1.25rem
          fontWeight: 500,    // Reduced from default 700
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        },
      }),
      // @ts-ignore - Custom error variant styling
      error: ({ theme }: { theme: Theme }) => ({
        color: theme.palette.error.light, // Use theme error color
        [theme.breakpoints.down('md')]: {
          fontWeight: 600,
        },
        [theme.breakpoints.up('md')]: {
          // Keep default desktop styles
        }
      }),
    },
  },
};
